export default "__VITE_ASSET__mgiJ4eKE__"